/**
 * @param {object} obj 
 * @param {string} path 
 * @returns
 */
export const getValue = (obj, path) => {
  if (!obj || !path) return null;
  const keys = path.split(".");
  let result = obj;

  for (let key of keys) {
    if (result && Object.prototype.hasOwnProperty.call(result, key)) {
      result = result[key];
    } else {
      return null;
    }
  }
  return result;
};